import { createAsyncThunk } from '@reduxjs/toolkit';
import { format } from 'date-fns';
import axiosInstance from 'utils/axios';

export const getAllRefund = createAsyncThunk('refund/getAllRefund', async (params, thunkAPI) => {
  const { page, limit, status } = params;

  let newUrl = `/admin/refund-orders`;

  if (page) {
    if (newUrl.includes('?')) {
      newUrl += `&page=${page}`;
    } else {
      newUrl += `?page=${page}`;
    }
  }

  if (limit) {
    if (newUrl.includes('?')) {
      newUrl += `&limit=${limit}`;
    } else {
      newUrl += `?limit=${limit}`;
    }
  }

  if (status && status.length !== 0) {
    for (let statusChild of status) {
      newUrl += `&status=${statusChild}`;
    }
  }

  try {
    const response = await axiosInstance.get(newUrl);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const getDetailRefund = createAsyncThunk('refund/getDetailRefund', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/refund-orders/${id}`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const updateStatusRefund = createAsyncThunk('refund/updateStatusRefund', async (payload, thunkAPI) => {
  const { id, ...payloadData } = payload;

  try {
    const response = await axiosInstance.put(`/admin/refund-orders/${id}`, {
      ...payloadData,
    });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getRefundHistories = createAsyncThunk('refund/getRefundHistories', async (params, thunkAPI) => {
  const { id, page, limit } = params;

  let newUrl = `/admin/refund-orders/${id}/histories`;

  if (page) {
    if (newUrl.includes('?')) {
      newUrl += `&page=${page}`;
    } else {
      newUrl += `?page=${page}`;
    }
  }

  if (limit) {
    if (newUrl.includes('?')) {
      newUrl += `&limit=${limit}`;
    } else {
      newUrl += `?limit=${limit}`;
    }
  }

  try {
    const response = await axiosInstance.get(newUrl);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const getRefundReports = createAsyncThunk('refund/getRefundReports', async ({ status }, thunkAPI) => {
  let mainUrl = `/admin/refund-orders/export`;

  if (status !== undefined) {
    status.map((item, idx) => {
      mainUrl += `${idx == 0 ? '?' : '&'}status[]=${item}`;
    });
  } else if (status === undefined) {
    mainUrl += `?status[]=CREATED&status[]=PROCESSED&status[]=REJECTED&status[]=TRANSFERED`;
  }

  try {
    const res = await axiosInstance.get(mainUrl, {
      responseType: 'blob',
    });
    const dateNow = format(new Date(), 'MM-dd-yyyy-hh-mm-ss');
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = `deposit-reports-${dateNow}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const importRefundReports = createAsyncThunk('refund/importRefundReports', async (file, thunkAPI) => {
  try {
    await axiosInstance.post(`/admin/refund-orders/import`, file, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const uploadImageRefund = createAsyncThunk('refund/uploadImageRefund', async (file, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/profile/document`, file, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
